import { } from '@vue/composition-api'
// import UserModulesModel from '@/app/nav_bar/models/Index'

export default function DropdownTradeMarketing (props, context) {
  // const userModules = props.data.map(rawUserModules => new UserModulesModel(rawUserModules))

  const filteredUserModules = props.data.filter(x => x.type === 'TRADE_MARKETING')

  return {
    filteredUserModules
  }
}



// WEBPACK FOOTER //
// ./src/app/nav_bar/compositions/DropdownTradeMarketing.js